module.exports = __webpack_public_path__ + "img/41.641a0c4e.jpg";